// This is a bit of a funky file -
// This just calls ALL necessary data for initial display
// And tracks that it's been loaded
// Managing the state of the loaded data is actually the domain of other reducers

// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/loading/';
export const actions = [
  'SET_ACTIVE_FIELD_UPDATING',
  'COMPLETE_ACTIVE_PRODUCT_YEAR_LOADING',
  'COMPLETE_ALL_CROPS_LOADING',
  'COMPLETE_AUTH_LOADING',
  'COMPLETE_BOUNDARY_LOADING',
  'COMPLETE_FIELDS_LOADING',
  'COMPLETE_FLAGS_LOADING',
  'COMPLETE_OPERATION_LOADING',
  'COMPLETE_PRODUCT_FEATURES_LOADING',
  'COMPLETE_SCRIPT_LIST_LOADING',
  'COMPLETE_USER_LOADING',
  'COMPLETE_ZONE_LOADING',
  'COMPLETE_ALL_FIELDS_PRODUCT_FEATURES_LOADING'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer ( // NOSONAR False-Positive, Reducer Exception
  state = {
    auth: 'unloaded',
    user: 'unloaded',
    year: 'unloaded',
    flags: 'unloaded',
    operation: 'unloaded',
    features: 'unloaded',
    fields: 'unloaded',
    boundary: 'unloaded',
    scripts: 'unloaded',
    crops: 'unloaded',
    zones: 'unloaded',
    allFieldsFeatures: 'unloaded'
  },
  action = {}
) {
  switch (action.type) {
    case actions.COMPLETE_AUTH_LOADING:
      return {...state, auth: 'fetched'};
    case actions.COMPLETE_USER_LOADING:
      return {...state, user: 'fetched'};
    case actions.COMPLETE_FIELDS_LOADING:
      return {...state, fields: 'fetched'};
    case actions.COMPLETE_FLAGS_LOADING:
      return {...state, flags: 'fetched'};
    case actions.COMPLETE_OPERATION_LOADING:
      return {...state, operation: 'fetched'};
    case actions.COMPLETE_PRODUCT_FEATURES_LOADING:
      return {...state, features: 'fetched'};
    case actions.COMPLETE_BOUNDARY_LOADING:
      return {...state, boundary: 'fetched'};
    case actions.COMPLETE_SCRIPT_LIST_LOADING:
      return {...state, scripts: 'fetched'};
    case actions.COMPLETE_ALL_CROPS_LOADING:
      return {...state, crops: 'fetched'};
    case actions.COMPLETE_ACTIVE_PRODUCT_YEAR_LOADING:
      return {...state, year: 'fetched'};
    case actions.SET_ACTIVE_FIELD_UPDATING:
      return {
        ...state,
        boundary: 'updating',
        features: 'updating',
        scripts: 'updating',
        zones: 'updating'
      };
    case actions.COMPLETE_ZONE_LOADING:
      return {...state, zones: 'fetched'};
    case actions.COMPLETE_ALL_FIELDS_PRODUCT_FEATURES_LOADING:
      return {...state, allFieldsFeatures: 'fetched'};
    default: return state;
  }
}

// Action Creators
// These should be called in a dispatch() function
// e.g. vraStore.dispatch(startAuthentication());

export const completeAuthentication = () => {
  return {
    type: actions.COMPLETE_AUTH_LOADING
  };
};

export const completeFieldsLoading = () => {
  return {
    type: actions.COMPLETE_FIELDS_LOADING
  };
};

export const completeFlagsLoading = () => {
  return {
    type: actions.COMPLETE_FLAGS_LOADING
  };
};

export const completeProductFeaturesLoading = () => {
  return {
    type: actions.COMPLETE_PRODUCT_FEATURES_LOADING
  };
};

export const completeBoundaryLoading = () => {
  return {
    type: actions.COMPLETE_BOUNDARY_LOADING
  };
};

export const completeUserId = () => {
  return {
    type: actions.COMPLETE_USER_LOADING
  };
};

export const completeOperationLoading = () => {
  return {
    type: actions.COMPLETE_OPERATION_LOADING
  };
};

export const completeScriptListLoading = () => {
  return {
    type: actions.COMPLETE_SCRIPT_LIST_LOADING
  };
};

export const completeCropListLoading = () => {
  return {
    type: actions.COMPLETE_ALL_CROPS_LOADING
  };
};

export const completeActiveProductYearLoading = () => {
  return {
    type: actions.COMPLETE_ACTIVE_PRODUCT_YEAR_LOADING
  };
};

export const completeZoneLoading = () => {
  return {
    type: actions.COMPLETE_ZONE_LOADING
  };
};

/** Set loading status to reflect that information is updating related to a newly set active field. */
export const setActiveFieldUpdating = () => {
  return {
    type: actions.SET_ACTIVE_FIELD_UPDATING
  };
};
